import { apiStatic, Loading, requestError } from 'AurionCR/components';
import { notifyRequestResult } from 'AurionCR/store/modules/notify';
import clsx from 'clsx';
import { validURL } from 'utils/validation';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'store';
import style from './index.module.scss';
import { InputLabel } from '@mui/material';
import { API_MEDIA_UPLOADS } from 'services/media-uploads';

export const HtmlPreview = ({
  apiGet = API_MEDIA_UPLOADS.GET_HTML_FROM_CLOUD,
  label,
  value,
  config,
}: {
  apiGet?: string;
  label?: React.ReactNode;
  value?: string;
  config?: { height?: string | number };
}) => {
  const dispatch = useAppDispatch();
  //state
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');
  // handlers
  const loadData = (value: string | undefined) => {
    setLoading(true);
    apiStatic
      .post(apiGet, { fileName: value })
      .then((response) => {
        setLoading(false);
        setContent(response.data);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        dispatch(notifyRequestResult(requestError(error), 'error'));
      });
  };
  // init
  useEffect(() => {
    if (value) {
      if (validURL(value)) {
        loadData(value);
      } else {
        setContent(value);
      }
    } else {
      setContent('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, setContent]);
  //render
  return (
    <div className={clsx('editor-wrapper', label && 'label')}>
      <div>
        {label && (
          <InputLabel shrink htmlFor="code-input">
            {label}
          </InputLabel>
        )}
      </div>
      <div
        className={clsx('native-scroll', 'scroll-size-s', style.html)}
        style={{ height: config?.height || '20rem' }}
      >
        <div className={'content'} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      <Loading active={loading} />
    </div>
  );
};
